<template>
  <v-app>
    <app-error-messages />
    <v-app-bar
      :class="{'border-b': !$capacitor.isNativeApp()}"
      app
      class="py-2"
      color="white"
      flat
    >
      <v-container>
        <v-row
          align="center"
          justify="center"
          justify-sm="space-between"
          no-gutters
        >
          <v-col
            cols="auto"
          >
            <router-link :to="$routeTo(ROUTES.LOGIN)">
              <v-img
                src="@/images/logo.svg"
                width="117"
              />
            </router-link>
          </v-col>
          <v-col
            v-if="! $capacitor.isNativeApp()"
            class="d-none d-sm-flex"
            cols="auto"
          >
            <v-btn
              :to="$routeTo(ROUTES.REGISTER)"
              size="default"
              variant="flat"
            >
              Sign up
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height">
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            lg="4"
            md="6"
            sm="8"
            xl="3"
          >
            <slot />
            <footer
              v-if="! $capacitor.isNativeApp() && ! $route.meta.withoutFooter"
              class="mt-8 text-center description"
            >
              <span class="description__text">
                Dont have an account?
              </span>
              <router-link
                class="text-primary font-weight-bold text-decoration-none"
                :to="$routeTo(ROUTES.REGISTER)"
              >
                Sign up
              </router-link>
            </footer>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import AppErrorMessages from "@/components/AppErrorMessages.vue"

export default defineComponent({
  components: {AppErrorMessages}
})
</script>

<style lang="scss" scoped>
.description {
  &__text {
    color: #475467;
  }
}
</style>
